<template>
    <v-container class="h-100">
        <v-card class="card-container">
            <v-card-title>
                <v-row>
                    <v-col cols="auto">
                        <v-btn
                                dense
                                color="var(--color-blue)"
                                @click="showActivateModal"
                                dark
                        >
                            <span class="btn-text"><iconItem iconName="gift" iconColor="white"></iconItem> Активировать бонус</span>
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                                color="var(--color-blue)"
                                outlined
                                @click="showAct"
                        >
                           <span><v-icon>mdi-printer</v-icon> Печать акта</span>
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-text-field
                                class="search-block"
                                v-model="search"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                solo
                                placeholder="Поиск клиента"
                                dense
                                hide-details
                        />
                    </v-col>
                    <v-col cols="auto">
                        <span class="subheader-label">Пакет:</span>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                                v-model="selectedPackages"
                                multiple
                                item-text="name"
                                item-value="id"
                                solo
                                dense
                                hide-details
                                :items="packageItems"
                        >
                            <template v-slot:prepend-item>
                                <v-list-item
                                        ripple
                                        @click="toogleAllPackagess"
                                >
                                    <v-list-item-action>
                                        <v-icon :color="selectedPackages.length > 0 ? 'indigo darken-4' : ''">
                                            {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Выбрать все
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <div v-if="likesAllPackages">
                                    <span v-if="index === 0">Все</span>
                                </div>
                                <div v-else>
                                    <span v-if="index === 0">{{ item.name }}</span>
                                    <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                    >
                                        (+{{ selectedPackages.length - 1 }})
                                    </span>
                                </div>

                            </template>
                        </v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>

            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="h-100 pt-0" style="overflow-y: scroll">
                <v-container class="bonus-tables-container">
                    <div class="table-header">Бонусы в обработке: {{activeCount}}</div>
                    <v-row v-if="activeCount==0" no-gutters class="no-bonuses">
                        <v-col align-self="center">
                            <div class="no-bonuses_text">Активируйте бонусный код для обработки</div>
                        </v-col>
                    </v-row>
                    <v-row v-else no-gutters >
                        <v-col>
                            <v-data-table
                                    :loading="loading"
                                    no-data-text="Нет элементов"
                                    no-results-text="Не найдено элементов"
                                    loading-text="Загрузка данных"
                                    calculate-widths
                                    :items-per-page="filteredActiveItems.length"
                                    :items="filteredActiveItems"
                                    :headers="fieldsActive"
                                    :search="search"
                                    height="100%"
                                    hide-default-footer
                                    class="elevation-1 h-100"
                            >
                                <template v-slot:item.registrationDate="{item}">
                                    <div>{{formatDate(item.registrationDate)}}</div>
                                </template>
                                <template v-slot:item.bonusPacket="{item}">
                                    <div :class="{'bonus-container':true,'bonus-1':item.bonusPacketCode=='BP01','bonus-2':item.bonusPacketCode=='BP02', 'bonus-3':item.bonusPacketCode=='BP03','bonus-0':item.bonusPacketCode=='BP00'}"><div>{{item.bonusPacket}}</div></div>
                                </template>

                                <template v-slot:item.actions="{item}">
                                    <div style="text-align: right">
                                        <v-btn @click="setCompleteBonus(item)" class="ml-4" color="var(--color-blue)" dark >Списать бонус</v-btn>
                                        <v-btn @click="cancelBonus(item)" class="ml-4" color="var(--color-3)" outlined >Отмена</v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <div class="table-header">История активации бонусов: {{historyCount}}</div>
                    <v-row no-gutters style="height: 100%">
                        <v-col>
                            <v-data-table
                                    :loading="loading"
                                    no-data-text="Нет элементов"
                                    no-results-text="Не найдено элементов"
                                    loading-text="Загрузка данных"
                                    calculate-widths
                                    :items-per-page="filteredHistoryItems.length"
                                    :items="filteredHistoryItems"
                                    :headers="fieldsHistory"
                                    :search="search"
                                    height="100%"
                                    hide-default-footer
                                    class="elevation-1 h-100"
                            >
                                <template v-slot:item.applyDate="{item}">
                                    <div>{{formatDate(item.applyDate)}}</div>
                                </template>
                                <template v-slot:item.registrationDate="{item}">
                                    <div>{{formatDate(item.registrationDate)}}</div>
                                </template>
                                <template v-slot:item.bonusPacket="{item}">
                                    <div :class="{'bonus-container':true,'bonus-1':item.bonusPacketCode=='BP01','bonus-2':item.bonusPacketCode=='BP02', 'bonus-3':item.bonusPacketCode=='BP03','bonus-0':item.bonusPacketCode=='BP00'}"><div>{{item.bonusPacket}}</div></div>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>

                </v-container>

            </v-card-text>
        </v-card>
        <activateBonusModal :show="activateModal" @close="closeActivateModal"></activateBonusModal>
    </v-container>
</template>

<script>
    const activateBonusModal= ()=> import("../components/ActivateBonus/AddBonusModal.vue")
    import iconItem from'../components/icons.vue'
    const docUrl=process.env.VUE_APP_DOCS
    export default {
        name: "ActivateBonus",
        components:{
            iconItem,
            activateBonusModal
        },
        data(){
            return {
                search:null,
                loading:false,
                selectedPackages:[],
                activateModal:false,
                fieldsHistory:[
                    {text: 'Бонус', value: 'bonus'},
                    {text: 'ФИО клиента', value: 'client'},
                    {text: 'Машина', value: 'clientCar'},
                    {text: 'Регистрация', value: 'registrationDate'},
                    {text: 'Пакет', value: 'bonusPacket'},
                    {text: 'Адрес', value: 'orgGeoInfo'},
                    {text: 'Исполнитель', value: 'webUser'},
                    {text: 'Дата списания', value: 'applyDate'},
                ],
                fieldsActive:[
                    {text: 'Бонус', value: 'bonus'},
                    {text: 'ФИО клиента', value: 'client'},
                    {text: 'Машина', value: 'clientCar'},
                    {text: 'Пакет', value: 'bonusPacket'},
                    {text: 'Регистрация', value: 'registrationDate'},
                    {text: '', value: 'actions'},
                ]
            }
        },
        created(){

            //получить список бонусных пакетов
            this.$store.dispatch("Bonuses/loadBonusPackages").catch(err=>{
                console.log(err)
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка пользователей!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });

        },
        mounted(){
          this.loadComplited()
          this.loadInWork()
        },
        computed:{
            activeCount(){
                return this.filteredActiveItems.length
            },

            historyCount(){
                return this.filteredHistoryItems.length
            },

            filteredActiveItems() {
                let items= this.$store.state.ActivationBonus.bonusesInWork
                if (items != null) {
                    if (this.selectedPackages.length > 0)
                        return items.filter((elem) => {
                            var intersection = this.selectedPackages.indexOf(elem.bonusPacketId) != -1;
                            if (intersection == true)
                                return true
                            else false
                        });
                    else return []
                }
                else return [];
            },

            filteredHistoryItems(){
                let items = this.$store.state.ActivationBonus.bonusesComplited
                if (items != null) {
                    if (this.selectedPackages.length > 0)
                        return items.filter((elem) => {
                            var intersection = this.selectedPackages.indexOf(elem.bonusPacketId) != -1;
                            if (intersection == true)
                                return true
                            else false
                        });
                    else return []
                }
                else return [];
            },

            packageItems(){
                return this.$store.state.Bonuses.bonusPackages
            },

            icon () {
                if (this.likesAllPackages) return 'mdi-close-box'
                if (this.likesSomePackages) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },

            likesSomePackages () {
                return this.selectedPackages.length > 0 && !this.likesAllPackages
            },

            likesAllPackages() {
                return this.selectedPackages.length === this.packageItems.length
            },
        },
        methods:{
            loadInWork(){
                this.$store.dispatch("ActivationBonus/loadBonusInWork").catch(error=>{
                    this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                        title: `Ошибка получения бонусов в работе!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            loadComplited(){
                this.$store.dispatch("ActivationBonus/loadBonusComplited").catch(error=>{
                    this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                        title: `Ошибка получения завершенных бонусов!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            showActivateModal(){
                this.activateModal=true
            },

            showAct(){
                window.open(`${docUrl}system/BonusAct.docx`)
            },

            closeActivateModal(isSave){
              this.activateModal=false
                if(isSave==true){
                    this.loadInWork()
                }
            },

            //отменить выполнение бонуса
            cancelBonus(item) {
                const vm = this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите отменить списание бонуса?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Подтвердить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            this.$store.dispatch("ActivationBonus/cancelBonus", item.id).then(() => {
                                this.loadInWork()
                            }).catch(error => {
                                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                    title: `Ошибка отмены бонуса!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                        }
                    })
            },

            //завершить бонус
            setCompleteBonus(item){
                const vm = this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите списать бонус?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Подтвердить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            this.$store.dispatch("ActivationBonus/setCompleteBonus", item.id).then(() => {
                                this.loadComplited()
                                this.loadInWork()
                            }).catch(error => {
                                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                    title: `Ошибка завершения бонуса!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                        }
                    })
            },

            toogleAllPackagess() {
                this.$nextTick(() => {
                    if (this.likesAllPackages) {
                        this.selectedPackages = []
                    }
                    else {
                        this.selectedPackages = []
                        this.packageItems.forEach(item => {
                            this.selectedPackages.push(item.id)
                        })
                    }
                })
            },



        },
        watch:{
            packageItems(value){
                if(value.length>0&&!this.likesAllPackages){
                    this.toogleAllPackagess()
                }
            }
        }
    }
</script>

<style scoped>
    .bonus-tables-container{
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-top: 0;
    }

    .no-bonuses{
        height: 80px;
        max-height: 80px;
        background: #F5F7FD;
    }

    .no-bonuses_text{
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: #6E7C8D;
        margin: 20px;
        vertical-align: middle;
    }

.table-header{
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    color:black;
    margin-top: 30px;
    margin-bottom: 20px;
}
</style>